import _extends from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _defineProperty from "/home/runner/work/loan-application-form/loan-application-form/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import PropTypes from 'prop-types';
import React from 'react';
import { Animated, Platform, processColor, StyleSheet } from 'react-native';
import createNativeWrapper from './createNativeWrapper';
import GestureHandlerButton from './GestureHandlerButton';
import State from './State';
export var RawButton = createNativeWrapper(GestureHandlerButton, {
  shouldCancelWhenOutside: false,
  shouldActivateOnStart: false
});
/* Buttons */

export var BaseButton =
/*#__PURE__*/
function (_React$Component) {
  _inherits(BaseButton, _React$Component);

  function BaseButton(props) {
    var _this;

    _classCallCheck(this, BaseButton);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BaseButton).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "_handleEvent", function (_ref) {
      var nativeEvent = _ref.nativeEvent;
      var state = nativeEvent.state,
          oldState = nativeEvent.oldState,
          pointerInside = nativeEvent.pointerInside;
      var active = pointerInside && state === State.ACTIVE;

      if (active !== _this._lastActive && _this.props.onActiveStateChange) {
        _this.props.onActiveStateChange(active);
      }

      if (oldState === State.ACTIVE && state !== State.CANCELLED && _this._lastActive && _this.props.onPress) {
        _this.props.onPress(active);
      }

      _this._lastActive = active;
    });

    _defineProperty(_assertThisInitialized(_this), "_onHandlerStateChange", function (e) {
      _this.props.onHandlerStateChange && _this.props.onHandlerStateChange(e);

      _this._handleEvent(e);
    });

    _defineProperty(_assertThisInitialized(_this), "_onGestureEvent", function (e) {
      _this.props.onGestureEvent && _this.props.onGestureEvent(e);

      _this._handleEvent(e);
    });

    _this._lastActive = false;
    return _this;
  }

  _createClass(BaseButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          style = _this$props.style,
          rippleColor = _this$props.rippleColor,
          rest = _objectWithoutProperties(_this$props, ["style", "rippleColor"]);

      return React.createElement(RawButton, _extends({
        style: [{
          overflow: 'hidden'
        }, style],
        rippleColor: processColor(rippleColor)
      }, rest, {
        onGestureEvent: this._onGestureEvent,
        onHandlerStateChange: this._onHandlerStateChange
      }));
    }
  }]);

  return BaseButton;
}(React.Component);

_defineProperty(BaseButton, "propTypes", _objectSpread({}, RawButton.propTypes, {
  onPress: PropTypes.func,
  onActiveStateChange: PropTypes.func
}));

var AnimatedBaseButton = Animated.createAnimatedComponent(BaseButton);
var btnStyles = StyleSheet.create({
  underlay: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    top: 0
  }
});
export var RectButton =
/*#__PURE__*/
function (_React$Component2) {
  _inherits(RectButton, _React$Component2);

  function RectButton(props) {
    var _this2;

    _classCallCheck(this, RectButton);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(RectButton).call(this, props));

    _defineProperty(_assertThisInitialized(_this2), "_onActiveStateChange", function (active) {
      if (Platform.OS !== 'android') {
        _this2._opacity.setValue(active ? _this2.props.activeOpacity : 0);
      }

      _this2.props.onActiveStateChange && _this2.props.onActiveStateChange(active);
    });

    _this2._opacity = new Animated.Value(0);
    return _this2;
  }

  _createClass(RectButton, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          rest = _objectWithoutProperties(_this$props2, ["children"]);

      return React.createElement(BaseButton, _extends({}, rest, {
        onActiveStateChange: this._onActiveStateChange
      }), React.createElement(Animated.View, {
        style: [btnStyles.underlay, {
          opacity: this._opacity
        }, {
          backgroundColor: this.props.underlayColor
        }]
      }), children);
    }
  }]);

  return RectButton;
}(React.Component);

_defineProperty(RectButton, "propTypes", BaseButton.propTypes);

_defineProperty(RectButton, "defaultProps", {
  activeOpacity: 0.105,
  underlayColor: 'black'
});

export var BorderlessButton =
/*#__PURE__*/
function (_React$Component3) {
  _inherits(BorderlessButton, _React$Component3);

  function BorderlessButton(props) {
    var _this3;

    _classCallCheck(this, BorderlessButton);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(BorderlessButton).call(this, props));

    _defineProperty(_assertThisInitialized(_this3), "_onActiveStateChange", function (active) {
      if (Platform.OS !== 'android') {
        _this3._opacity.setValue(active ? _this3.props.activeOpacity : 1);
      }

      _this3.props.onActiveStateChange && _this3.props.onActiveStateChange(active);
    });

    _this3._opacity = new Animated.Value(1);
    return _this3;
  }

  _createClass(BorderlessButton, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          children = _this$props3.children,
          style = _this$props3.style,
          rest = _objectWithoutProperties(_this$props3, ["children", "style"]);

      return React.createElement(AnimatedBaseButton, _extends({}, rest, {
        onActiveStateChange: this._onActiveStateChange,
        style: [style, Platform.OS === 'ios' && {
          opacity: this._opacity
        }]
      }), children);
    }
  }]);

  return BorderlessButton;
}(React.Component);

_defineProperty(BorderlessButton, "propTypes", _objectSpread({}, BaseButton.propTypes, {
  borderless: PropTypes.bool
}));

_defineProperty(BorderlessButton, "defaultProps", {
  activeOpacity: 0.3,
  borderless: true
});

export { default as PureNativeButton } from './GestureHandlerButton';